import React from 'react';
import { useNavigate } from 'react-router-dom';

const UPGRADE_PATHS = {
  buyer: {
    icon: '🛒',
    label: 'Become a Buyer',
    description: 'Shop for fresh produce from local farms and hubs',
    course: 'Buyer Course (8 modules)',
    slug: 'buyer-module-1-welcome',
    color: 'border-green-300 hover:bg-green-50'
  },
  kin_coordinator: {
    icon: '🌟',
    label: 'Become a Kin Coordinator',
    description: 'Start and lead a buying group',
    course: 'Kin Course (8 modules)',
    slug: 'kin-module-1-what-is-a-kin',
    color: 'border-yellow-300 hover:bg-yellow-50'
  },
  producer: {
    icon: '🚜',
    label: 'Become a Producer',
    description: 'Sell your farm products',
    course: 'Producer Course (8 modules)',
    slug: 'producer-module-1-welcome',
    color: 'border-green-300 hover:bg-green-50'
  },
  hub: {
    icon: '🏪',
    label: 'Become a Hub',
    description: 'Aggregate and sell from multiple producers',
    course: 'Hub Course (8 modules)',
    slug: 'hub-module-1-welcome',
    color: 'border-blue-300 hover:bg-blue-50'
  },
  pickup: {
    icon: '📦',
    label: 'Become a Pickup',
    description: 'Deliver orders and earn credits or cash',
    course: 'Pickup Course (8 modules)',
    slug: 'pickup-module-1-welcome',
    color: 'border-orange-300 hover:bg-orange-50'
  },
  educator: {
    icon: '🎓',
    label: 'Become an Educator',
    description: 'Create educational content and earn commissions',
    course: 'Educator Course (8 modules)',
    slug: 'educator-module-1-welcome',
    color: 'border-purple-300 hover:bg-purple-50'
  }
};

export default function UpgradeOptions({ onNavigate, onClose }) {
  const navigate = useNavigate();

  const handleUpgrade = (slug) => {
    onClose();
    navigate(`/learn/${slug}`);
  };

  return (
    <div className="space-y-2">
      <p className="text-xs text-gray-500 font-medium uppercase tracking-wider mb-2">
        🚀 Upgrade Options
      </p>
      <div className="space-y-2">
        {Object.entries(UPGRADE_PATHS).map(([key, option]) => (
          <button
            key={key}
            onClick={() => handleUpgrade(option.slug)}
            className={`w-full text-left p-3 border-2 rounded-lg transition ${option.color}`}
          >
            <div className="flex items-center gap-3">
              <span className="text-2xl">{option.icon}</span>
              <div className="flex-1">
                <div className="font-semibold text-sm">{option.label}</div>
                <div className="text-xs text-gray-600">{option.description}</div>
                <div className="text-xs text-gray-400 mt-0.5">📚 {option.course}</div>
              </div>
              <span className="text-gray-400">→</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
